module.exports = __webpack_public_path__ + "static/media/wix6.6eb84850.png";